import React, { useState, useEffect } from "react";
import { logout } from "../../utils/auth";
import BatchPublicView from "./BatchPublicView";

export default function UserDashboard() {
  const [batchNumber, setBatchNumber] = useState("");
  const [searchBatch, setSearchBatch] = useState(null);
  const [history, setHistory] = useState([]);

  const handleSearch = () => {
    if (!batchNumber.trim()) return;

    const bn = batchNumber.trim().toUpperCase();
    setSearchBatch(bn);

    // store history
    setHistory((prev) => {
      const updated = [bn, ...prev.filter((x) => x !== bn)];
      return updated.slice(0, 5);
    });
  };

  const loadFromHistory = (bn) => {
    setBatchNumber(bn);
    setSearchBatch(bn);
  };

  return (
    <div className="container-fluid py-4 px-3 px-md-5">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h3 className="fw-bold mb-0">Dashboard</h3>
          <small className="text-muted">
            Verify product authenticity & batch reports
          </small>
        </div>

        <button className="btn btn-outline-danger" onClick={logout}>
          Logout
        </button>
      </div>

      {/* WELCOME */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <h5 className="fw-bold mb-1">Welcome to Orgavitaz Portal</h5>
          <p className="text-muted mb-0">
            Enter a batch number or scan QR code to verify authenticity.
          </p>
        </div>
      </div>

      {/* SEARCH */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <h5 className="fw-bold mb-3">Verify Batch</h5>

          <div className="row g-2">
            <div className="col-md-8">
              <input
                className="form-control"
                placeholder="Enter Batch Number"
                value={batchNumber}
                onChange={(e) => setBatchNumber(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              />
            </div>

            <div className="col-md-4">
              <button className="btn btn-success w-100" onClick={handleSearch}>
                Search
              </button>
            </div>
          </div>

          {/* HISTORY */}
          {history.length > 0 && (
            <div className="mt-3">
              <small className="text-muted">Recent searches:</small>
              <div className="d-flex flex-wrap gap-2 mt-2">
                {history.map((h) => (
                  <button
                    key={h}
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => loadFromHistory(h)}
                  >
                    {h}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* RESULT */}
      {searchBatch && (
        <div className="mt-4">
          <BatchPublicView batchNumber={searchBatch} />
        </div>
      )}
    </div>
  );
}
